// import React, { useState } from "react";
// import Field from "./Field";
// import useStyles from "./styles";
// import backgroundImg from "../../assets/background.jpg"; // Add a background image
// import logo from "../../assets/logo.jpg";

// import { createTheme, ThemeProvider, useTheme } from "@material-ui/core/styles";
// import {
//   Paper,
//   Grid,
//   Container,
//   useMediaQuery,
//   Box,
//   Typography,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogTitle,
//   Button,
// } from "@material-ui/core";
// import { useDispatch } from "react-redux";
// import { useHistory, Link } from "react-router-dom";
// import { signup, signin } from "../../actions/auth";
// import { useSnackbar } from "react-simple-snackbar";
// import CircularProgress from "@material-ui/core/CircularProgress";

// import styles from "./Login.module.css";

// const initialState = {
//   firstName: "",
//   lastName: "",
//   email: "",
//   password: "",
//   confirmPassword: "",
// };

// const colorTheme = createTheme({
//   palette: {
//     primary: {
//       main: "#ef7f1a",
//     },
//     background: {
//       default: "#f4f4f4",
//     },
//   },
//   typography: {
//     fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
//   },
//   overrides: {
//     MuiPaper: {
//       root: {
//         borderRadius: 12,
//         boxShadow: "0 8px 20px rgba(0,0,0,0.1)",
//       },
//     },
//   },
// });

// const Login = () => {
//   const classes = useStyles();
//   const theme = useTheme();
//   const [formData, setFormData] = useState(initialState);
//   const [isSignup, setIsSignup] = useState(false);
//   const dispatch = useDispatch();
//   const history = useHistory();
//   const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
//   const [showPassword, setShowPassword] = useState(false);
//   const [openSnackbar] = useSnackbar();
//   const [loading, setLoading] = useState(false);
//   const [errors, setErrors] = useState({});

//   const [reminderData, setReminderData] = useState(null);
//   const [showReminder, setShowReminder] = useState(false);

//   const handleShowPassword = () => setShowPassword(!showPassword);

//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//     setErrors((prevErrors) => ({ ...prevErrors, [e.target.name]: "" }));
//   };

//   const validateForm = () => {
//     const errors = {};
//     let isValid = true;
//     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

//     if (!formData.email.trim()) {
//       errors.email = "Email is required.";
//       isValid = false;
//     } else if (!emailRegex.test(formData.email)) {
//       errors.email = "Invalid email format.";
//       isValid = false;
//     }

//     if (!formData.password.trim()) {
//       errors.password = "Password is required.";
//       isValid = false;
//     }

//     if (isSignup && formData.password !== formData.confirmPassword) {
//       errors.confirmPassword = "Passwords do not match.";
//       isValid = false;
//     }

//     setErrors(errors);
//     return isValid;
//   };

//   // const handleSubmit = (e) => {
//   //   e.preventDefault();
//   //   if (!validateForm()) return;

//   //   setLoading(true);
//   //   if (isSignup) {
//   //     dispatch(signin(formData, openSnackbar, setLoading)).then((res) => {
//   //       if (res?.reminder) {
//   //         setShowReminder(res); // open dialog
//   //       } else if (res?.token) {
//   //         history.push("/dashboard");
//   //       }
//   //     });
//   //   } else {
//   //     dispatch(signin(formData, openSnackbar, setLoading));
//   //   }
//   // };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!validateForm()) return;

//     setLoading(true);

//     try {
//       if (isSignup) {
//         // =========================
//         // SIGNUP FLOW
//         // =========================
//         const res = await dispatch(signup(formData, setLoading));

//         if (res?.token) {
//           history.push("/dashboard"); // redirect after signup
//         }
//         setLoading(false);
//         return;
//       }

//       // =========================
//       // LOGIN FLOW
//       // =========================
//       const res = await dispatch(signin(formData, setLoading));

//       // ❌ Expired → block login
//       if (res?.expired) {
//         setExpiredData(res);
//         setShowExpired(true);
//         return;
//       }

//       // ⚠ Reminder → allow login
//       if (res?.reminder?.reminder) {
//         setReminderData(res.reminder);
//         setShowReminder(true);
//         return;
//       }

//       // ✔ Normal login
//       if (res?.token) {
//         history.push("/dashboard");
//       }

//     } catch (errMsg) {
//       openSnackbar(errMsg, "error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const switchMode = () => {
//     setIsSignup((prevState) => !prevState);
//   };

//   return (
//     <Container
//       component="main"
//       maxWidth="xs"
//       style={{
//         minHeight: isMobile ? "740px" : "100vh",
//       }}
//     >
//       <ThemeProvider theme={colorTheme}>
//         <Paper
//           elevation={3}
//           style={{
//             padding: theme.spacing(4),
//             display: "flex",
//             flexDirection: "column",
//             alignItems: "center",
//             backgroundColor: "rgba(255,255,255,0.9)",
//             backdropFilter: "blur(10px)",
//             borderRadius: 12,
//             width: "100%",
//             maxWidth: 400,
//           }}
//         >
//           <Box
//             sx={{
//               width: "150px",
//               height: "150px",
//               mb: 1,
//               display: "flex",
//               justifyContent: "center",
//               alignItems: "center",
//             }}
//           >
//             <img
//               src={logo}
//               alt="Company Logo"
//               style={{
//                 maxWidth: "100%",
//                 maxHeight: "100%",
//                 objectFit: "contain",
//               }}
//             />
//           </Box>

//           <Typography
//             component="h1"
//             variant="h5"
//             style={{
//               marginBottom: theme.spacing(1),
//               color: theme.palette.primary.main,
//               fontWeight: 600,
//             }}
//           >
//             {isSignup ? "Create an Account" : "Welcome Back"}
//           </Typography>

//           <form className={classes.form} onSubmit={handleSubmit}>
//             <Grid container spacing={2}>
//               {isSignup && (
//                 <>
//                   <Field
//                     name="firstName"
//                     label="First Name"
//                     handleChange={handleChange}
//                     autoFocus
//                     half
//                   />
//                   <Field
//                     name="lastName"
//                     label="Last Name"
//                     handleChange={handleChange}
//                     half
//                   />
//                 </>
//               )}

//               <Field
//                 name="email"
//                 label="Email"
//                 handleChange={handleChange}
//                 type="email"
//                 error={errors.email}
//               />
//               <Field
//                 name="password"
//                 label="Password"
//                 handleChange={handleChange}
//                 type={showPassword ? "text" : "password"}
//                 handleShowPassword={handleShowPassword}
//                 error={errors.password}
//               />
//               {isSignup && (
//                 <Field
//                   name="confirmPassword"
//                   label="Confirm Password"
//                   handleChange={handleChange}
//                   type="password"
//                   error={errors.confirmPassword}
//                 />
//               )}
//             </Grid>

//             <div
//               className={styles.buttons}
//               style={{ marginTop: theme.spacing(2) }}
//             >
//               <div>
//                 {loading ? (
//                   <Box display="flex" justifyContent="center" width="100%">
//                     <CircularProgress color="primary" />
//                   </Box>
//                 ) : (
//                   <button
//                     className={styles.loginBtn}
//                     type="submit"
//                     style={{
//                       backgroundColor: theme.palette.primary.main,
//                       color: "white",
//                       borderRadius: 8,
//                       padding: "10px 20px",
//                       width: "100%",
//                       border: "none",
//                       fontWeight: 600,
//                       transition: "background-color 0.3s ease",
//                     }}
//                   >
//                     {isSignup ? "Sign Up" : "Log In"}
//                   </button>
//                 )}
//               </div>
//             </div>

//             <Box
//               mt={2}
//               textAlign="center"
//               style={{
//                 display: "flex",
//                 justifyContent: "space-between",
//                 alignItems: "center",
//               }}
//             >
//               <Typography variant="body2">
//                 {isSignup
//                   ? "Already have an account? "
//                   : "Don't have an account? "}
//                 <span
//                   onClick={switchMode}
//                   style={{
//                     color: theme.palette.primary.main,
//                     cursor: "pointer",
//                     fontWeight: 600,
//                     marginLeft: 5,
//                   }}
//                 >
//                   {isSignup ? "Log In" : "Sign Up"}
//                 </span>
//               </Typography>

//               <Link
//                 to="forgot"
//                 style={{
//                   color: "#1d7dd6",
//                   textDecoration: "none",
//                   fontWeight: 500,
//                 }}
//               >
//                 Forgot Password?
//               </Link>
//             </Box>
//           </form>
//           <Dialog open={showReminder} onClose={() => setShowReminder(false)}>
//   <DialogTitle>Subscription Expiry Warning</DialogTitle>
//   <DialogContent>
//     <Typography>
//       Your subscription will expire in <strong>{reminderData?.daysLeft} days</strong>.
//     </Typography>
//     <Typography>Expiry Date: <strong>{new Date(reminderData?.expiryDate).toDateString()}</strong></Typography>
//   </DialogContent>
//   <DialogActions>
//     <Button onClick={() => setShowReminder(false)}>Cancel</Button>
//     <Button
//       onClick={() => {
//         setShowReminder(false);
//         history.push("/dashboard");
//       }}
//       color="primary"
//       variant="contained"
//     >
//       Confirm Login
//     </Button>
//   </DialogActions>
//           </Dialog>

//         </Paper>
//       </ThemeProvider>
//     </Container>
//   );
// };

// export default Login;

import React, { useState } from "react";
import Field from "./Field";
import useStyles from "./styles";
import logo from "../../assets/logo.jpg";
import { useSnackbar } from "react-simple-snackbar";

import { createTheme, ThemeProvider, useTheme } from "@material-ui/core/styles";
import {
  Paper,
  Grid,
  Container,
  useMediaQuery,
  Box,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  CircularProgress,
} from "@material-ui/core";
import { useDispatch } from "react-redux";
import { useHistory, Link } from "react-router-dom";
import { signup, signin } from "../../actions/auth";

const initialState = {
  firstName: "",
  lastName: "",
  email: "",
  password: "",
  confirmPassword: "",
};

const colorTheme = createTheme({
  palette: {
    primary: { main: "#ef7f1a" },
    background: { default: "#f4f4f4" },
  },
  typography: { fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif' },
});

const Login = () => {
  const classes = useStyles();
  const theme = useTheme();
  const dispatch = useDispatch();
  const history = useHistory();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const [formData, setFormData] = useState(initialState);
  const [isSignup, setIsSignup] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const [openSnackbar] = useSnackbar();

  // Reminder modal
  const [showReminder, setShowReminder] = useState(false);
  const [reminderData, setReminderData] = useState(null);

  // Expired modal
  const [showExpired, setShowExpired] = useState(false);
  const [expiredData, setExpiredData] = useState(null);
  const user = JSON.parse(localStorage.getItem("profile"));

  const handleShowPassword = () => setShowPassword(!showPassword);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors((prev) => ({ ...prev, [e.target.name]: "" }));
  };

  const validateForm = () => {
    const errors = {};
    let isValid = true;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!formData.email.trim()) {
      errors.email = "Email is required";
      isValid = false;
    } else if (!emailRegex.test(formData.email)) {
      errors.email = "Invalid email format";
      isValid = false;
    }

    if (!formData.password.trim()) {
      errors.password = "Password is required";
      isValid = false;
    }

    if (isSignup && formData.password !== formData.confirmPassword) {
      errors.confirmPassword = "Passwords do not match";
      isValid = false;
    }

    setErrors(errors);
    return isValid;
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   if (!validateForm()) return;

  //   setLoading(true);

  //   // try {
  //   //   if (isSignup) {
  //   //     const res = await dispatch(signup(formData, setLoading));
  //   //     if (res?.token) history.push("/dashboard");
  //   //     return;
  //   //   }

  //   //   const res = await dispatch(signin(formData, setLoading));

  //   //   // ❌ Subscription expired
  //   //   if (res?.expired) {
  //   //     setExpiredData(res);
  //   //     setShowExpired(true);
  //   //     return;
  //   //   }

  //   //   // ⚠ Subscription reminder (login allowed)
  //   //   if (res?.reminder?.reminder) {
  //   //     setReminderData(res.reminder);
  //   //     setShowReminder(true);
  //   //     return;
  //   //   }

  //   //   // ✔ Successful login
  //   //   if (res?.token) {
  //   //     history.push("/dashboard");
  //   //   }
  //   // } catch (err) {
  //   //   console.error(err);
  //   // } finally {
  //   //   setLoading(false);
  //   // }

  //   try {
  //     const res = await dispatch(signin(formData, setLoading));

  //     // ⚠ Normal login
  //     if (res?.token) {
  //       // If there's a reminder, show dialog
  //       if (res?.reminder?.reminder) {
  //         setReminderData(res.reminder);
  //         setShowReminder(true);
  //         return;
  //       }

  //       // Normal login
  //       history.push("/dashboard");
  //     }
  //   } catch (error) {
  //     // ❌ Here we catch 403 from server
  //     if (error?.response?.status === 403) {
  //       // Show expired dialog
  //       setExpiredData({ message: error.response.data.message });
  //       setShowExpired(true);
  //     } else {
  //       // Other errors
  //       console.log(error?.response?.data?.message);
  //       openSnackbar(error?.response?.data?.message || "Something went wrong", "error");
  //     }
  //   } finally {
  //     setLoading(false);
  //   }

  // };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   if (!validateForm()) return;

  //   setLoading(true);

  //   try {
  //     if (isSignup) {
  //       const res = await dispatch(signup(formData, setLoading));
  //       if (res?.token) history.push("/dashboard");
  //       return;
  //     }

  //     const res = await dispatch(signin(formData, openSnackbar, setLoading));
  //     console.log("res", res)

  //     if (res?.expired) {
  //       // ⛔ Show expired dialog
  //       setExpiredData(res);
  //       setShowExpired(true);
  //       return;
  //     }

  //     if (res?.reminder?.reminder) {
  //       // ⚠ Show reminder dialog but allow login
  //       setReminderData(res.reminder);
  //       setShowReminder(true);
  //       return;
  //     }

  //     if (res?.token) {
  //       // Redirect superAdmin to Subscription page, others to dashboard
  //       if (res?.result?.userType === "superAdmin") {
  //         history.push("/Subscribers");
  //       } else {
  //         history.push("/dashboard");
  //       }
  //     }
  //   } catch (err) {
  //     openSnackbar(err?.message || "Something went wrong", "error");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
  
    setLoading(true);
  
    try {
      if (isSignup) {
        const res = await dispatch(signup(formData, setLoading));
        if (res?.token) history.push("/dashboard");
        return;
      }
  
      const res = await dispatch(signin(formData, openSnackbar, setLoading));
      console.log("res", res);
  
      // ❌ Subscription expired
      if (res?.expired) {
        setExpiredData(res);
        setShowExpired(true);
        return;
      }
  
      // ⚠ Show reminder pop-up (still allow login)
      if (res?.reminder?.reminder) {
        setReminderData(res.reminder);
        setShowReminder(true);
        return;
      }
  
      // ✅ Successful login
      if (res?.token) {
        if (res?.result?.userType === "superAdmin") {
          // SUPER ADMIN → use full reload
          window.location.href = "/Subscribers";
        } else {
          // Normal users → normal react navigation
          window.location.href = "/invoices";
        }
      }
    } catch (err) {
      openSnackbar(err?.message || "Something went wrong", "error");
    } finally {
      setLoading(false);
    }
  };
  


  const switchMode = () => setIsSignup((prev) => !prev);

  return (
    <Container
      component="main"
      maxWidth="xs"
      style={{ minHeight: isMobile ? "740px" : "100vh" }}
    >
      <ThemeProvider theme={colorTheme}>
        <Paper
          elevation={3}
          style={{
            padding: theme.spacing(4),
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            backgroundColor: "rgba(255,255,255,0.9)",
            backdropFilter: "blur(10px)",
            borderRadius: 12,
            width: "100%",
            maxWidth: 400,
          }}
        >
          <Box
            sx={{
              width: 150,
              height: 150,
              mb: 1,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img
              src={logo}
              alt="Company Logo"
              style={{
                maxWidth: "100%",
                maxHeight: "100%",
                objectFit: "contain",
              }}
            />
          </Box>

          <Typography
            component="h1"
            variant="h5"
            style={{
              marginBottom: theme.spacing(1),
              color: theme.palette.primary.main,
              fontWeight: 600,
            }}
          >
            {isSignup ? "Create an Account" : "Welcome Back"}
          </Typography>

          <form className={classes.form} onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              {isSignup && (
                <>
                  <Field
                    name="firstName"
                    label="First Name"
                    handleChange={handleChange}
                    autoFocus
                    half
                  />
                  <Field
                    name="lastName"
                    label="Last Name"
                    handleChange={handleChange}
                    half
                  />
                </>
              )}

              <Field
                name="email"
                label="Email"
                handleChange={handleChange}
                type="email"
                error={errors.email}
              />
              <Field
                name="password"
                label="Password"
                handleChange={handleChange}
                type={showPassword ? "text" : "password"}
                handleShowPassword={handleShowPassword}
                error={errors.password}
              />
              {isSignup && (
                <Field
                  name="confirmPassword"
                  label="Confirm Password"
                  handleChange={handleChange}
                  type="password"
                  error={errors.confirmPassword}
                />
              )}
            </Grid>

            <div style={{ marginTop: theme.spacing(2) }}>
              {loading ? (
                <Box display="flex" justifyContent="center" width="100%">
                  <CircularProgress color="primary" />
                </Box>
              ) : (
                <button
                  type="submit"
                  style={{
                    backgroundColor: theme.palette.primary.main,
                    color: "white",
                    borderRadius: 8,
                    padding: "10px 20px",
                    width: "100%",
                    border: "none",
                    fontWeight: 600,
                    transition: "background-color 0.3s ease",
                  }}
                >
                  {isSignup ? "Sign Up" : "Log In"}
                </button>
              )}
            </div>

            <Box
              mt={2}
              textAlign="center"
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <Typography variant="body2">
                {isSignup
                  ? "Already have an account?"
                  : "Don't have an account?"}
                <span
                  onClick={switchMode}
                  style={{
                    color: theme.palette.primary.main,
                    cursor: "pointer",
                    fontWeight: 600,
                    marginLeft: 5,
                  }}
                >
                  {isSignup ? "Log In" : "Sign Up"}
                </span>
              </Typography>
              <Link
                to="forgot"
                style={{
                  color: "#1d7dd6",
                  textDecoration: "none",
                  fontWeight: 500,
                }}
              >
                Forgot Password?
              </Link>
            </Box>
          </form>

          {/* REMINDER DIALOG */}
          <Dialog open={showReminder} onClose={() => setShowReminder(false)}>
            <DialogTitle style={{ color: "red" }}>
              Subscription Expiry Alert
            </DialogTitle>


            <DialogContent>
              <Typography>
                Your subscription will expire in{" "}
                <strong>{reminderData?.daysLeft} days</strong>.
              </Typography>
              <Typography>
                Expiry Date:{" "}
                <strong>
                {new Date(reminderData?.expiryDate).toLocaleDateString("en-US", {
                  month: "short",
                  day: "numeric",
                  year: "numeric",
                })}
                </strong>
              </Typography>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setShowReminder(false)}>Cancel</Button>
              <Button
                onClick={() => {
                  setShowReminder(false);
                  // Get user type from localStorage to determine redirect
                  const storedUser = JSON.parse(localStorage.getItem("profile"));
                  if (storedUser?.result?.userType === "superAdmin") {
                    window.location.href = "/Subscribers";
                  } else {
                    window.location.href = "/invoices";
                  }
                }}
                color="primary"
                variant="contained"
              >
                Confirm Login
              </Button>
            </DialogActions>
          </Dialog>

          {/* EXPIRED DIALOG */}
          <Dialog open={showExpired} onClose={() => setShowExpired(false)}>
            <DialogTitle style={{ color: "red" }}>Subscription Expired</DialogTitle>
            <DialogContent>
              <Typography>{expiredData?.message}</Typography>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => setShowExpired(false)}
                color="primary"
                variant="contained"
                style={{ color: "white" }}
              >
                OK
              </Button>

            </DialogActions>
          </Dialog>
        </Paper>
      </ThemeProvider>
    </Container>
  );
};

export default Login;
